import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "UPDATE_CARRIER_RESPONSIBLE_EMAIL_" }
);

export interface UpdateCarrierResponsibleEmailState extends IState {}

const INITIAL_STATE: UpdateCarrierResponsibleEmailState = {
  loading: false,
  error: null,
};

const request = (state: UpdateCarrierResponsibleEmailState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: UpdateCarrierResponsibleEmailState,
  action: ISuccessAction
) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (
  state: UpdateCarrierResponsibleEmailState,
  action: IFailureAction
) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const updateCarrierResponsibleEmail = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const UpdateCarrierResponsibleEmailTypes = Types;
export const UpdateCarrierResponsibleEmailActions = Creators;
